// Add this to prevent a Next.js build error in Contentful
'use client';

// Auto-import SASS generated CSS
import './index.css';

export {VideoProps} from './types';

export {default as Video} from './Video';
export {default as default} from './Video';
